import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { errorColorLight, errorColorLighter } from '~theme';

const Input = styled.input`
  ${props =>
    props.error &&
    css`
      border-color: ${errorColorLight};
      &:focus {
        box-shadow: inset 0px 1px 1px rgba(0, 0, 0, 0.075),
          0px 0px 6px ${errorColorLighter};
      }
    `};
`;
const Textarea = styled.textarea`
  ${props =>
    props.error &&
    css`
      border-color: ${errorColorLight};
      &:focus {
        box-shadow: inset 0px 1px 1px rgba(0, 0, 0, 0.075),
          0px 0px 6px ${errorColorLighter};
      }
    `};
`;

const propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string.isRequired,
  required: PropTypes.bool,
  meta: PropTypes.object.isRequired,
};

const ReduxFormControl = ({
  input,
  label,
  element,
  placeholder,
  type,
  required,
  meta: { touched, error, warning },
  ...rest
}) => {
  const InputEl = element && element === 'textarea' ? Textarea : Input;

  return (
    <ReduxFormControlEl>
      <Label required={required}>{label}</Label>
      <InputEl
        {...input}
        {...rest}
        className="form-control"
        placeholder={placeholder}
        type={type}
        error={touched && error}
      />
      <ErrorMessage>
        {touched &&
          ((error && <span>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </ErrorMessage>
    </ReduxFormControlEl>
  );
};

const ReduxFormControlEl = styled.div`
  margin-bottom: 16px;
`;
const ErrorMessage = styled.span`
  color: ${errorColorLight};
  font-size: 10px;
  margin-top: 3px;
  height: 14px;
`;
/* eslint-disable no-useless-escape */
export const Label = styled.label`
  font-weight: 400;
  font-size: 0.7em;
  padding-left: 5px;
  margin-bottom: 3px;
  height: 15px;
  position: relative;
  /* ${props => props.required && 'font-weight: 700'}; */

  &:after {
    font-weight: normal;
    content: ${props => (props.required ? '"*"' : '""')};
    color: red;
    position: absolute;
    margin-left: 3px;
    top: 1px;
    font-size: 16px;
  }
`;
/*
@media screen and (max-width: 470px) {
  font-size: 0.85em;
  margin-bottom: 5px;
}
*/
/* eslint-disable no-useless-escape */

ReduxFormControl.propTypes = propTypes;
export default ReduxFormControl;
